
import superagent from "superagent";

const getCalculator = calc_id => {

  return new Promise((resolve, reject) => {
    return superagent.agent()
      .get("/api/calculator/" + calc_id)
      .then(result => {
        return resolve(result.body);
      })
  });
}

export { getCalculator };
